module.exports = function getResource(label, vars = []) {
    const resources = {
        subscribeToFlash: 'Inscrivez-vous à Sephora FLASH et profitez de la livraison gratuite sans achat minimum pendant une année entière.',
        noSubscriptionsAvailable: 'Nous sommes désolés, aucun abonnement n’est disponible actuellement.',
        eligibleForFreeFlash: 'Vous êtes admissible à un abonnement GRATUIT Sephora FLASH à titre de cadeau de célébration Rouge. Rendez-vous à votre',
        beautyInsiderPage: 'page Beauty Insider',
        toLearnMore: 'pour en savoir plus.',
        byClickingAddToBasket: 'En cliquant sur « Ajouter au panier », vous acceptez Sephora FLASH.',
        termsAndConditions: 'modalités',
        started: 'Début',
        ends: 'Fin',
        billedTo: 'Facturé à',
        cancelAutoRenew: 'Annuler l’auto-renouvellement',
        sephoraFlash: 'Sephora FLASH',
        learnMore: 'En savoir plus',
        cancelAutoRenewal: 'Annuler l’auto-renouvellement Sephora FLASH',
        cancelAutoRenewalMessage: `<p>Vous pouvez annuler le renouvellement automatique de votre abonnement à Sephora FLASH. Votre carte ne sera pas débitée à la date de renouvellement.</p><p>Vous obtiendrez tout de même la livraison flash gratuite sans achat minimum jusqu’à la fin de votre adhésion actuelle, <b>${vars[0]}</b>.</p>`,
        cancelAutoRenewalMessageShort: `<p>L’auto-renouvellement de votre inscription Sephora FLASH a été annulée.</p> <p>Vos avantages d’expédition prendront fin le <b>${vars[0]}</b>.</p>`,
        sephoraFlashTermsAndConditions: 'Conditions générales de Sephora FLASH'
    };

    return resources[label];
};
